




















































































































































































import { Component, Vue } from 'vue-property-decorator';
import AppModal from '../../shared/components/ui/Modal.vue';
import { Getter, Mutation } from 'vuex-class'
import { ADDFUNDS_IS_OPEN, CLOSE_ADDFUNDS } from "./store/constants";
import addFundsService from "./services/AddFundsService";

import { USERNAME } from '@/modules/auth/store/constants';

@Component({
    components: {
        AppModal,
    },
})
export default class AddFunds extends Vue {
    @Getter(ADDFUNDS_IS_OPEN) private showModal!: boolean;
    @Mutation(CLOSE_ADDFUNDS) private closeModal!: Function;
    @Getter(USERNAME) private username!: string;

    private geoCode = '';
    private coinbaseData = {
        success: false,
        addresses: {
            bitcoincash: '',
            bitcoin: '',
            dai: '',
            ethereum: '',
            litecoin: '',
            usdc: '',
        },
        hosted_url: '',
        message: '',
        username: '',
    };

    private data = {
        amount: 0,
        method: [],
    };

    private close() {
        this.coinbaseData.success = false;
        this.data = {
            amount: 0,
            method: [],
        };
        this.closeModal()
    }

    private onChangePaymentMethod(e: any) {
        const { value } = e.target;
        if (value) {
            // @ts-ignore
            this.data.method = [value];
        }
    }

    private async confirmWithDirecta24(amount: number) {
        const payload = {
            username: this.username,
            ggcAmount: parseFloat(String(amount * 100)),
            country: this.geoCode,
            language: 'es',
            successUrl: 'https://golagol.com' + '?payment_success=1',
            backUrl: 'https://golagol.com' + '?payment_success=0',
            errorUrl: 'https://golagol.com' + '?payment_success=0',
        };

        try {
            await addFundsService.directa24Deposit(payload)
        } catch (e) {
            (this as any).$notify({
                group: 'errors',
                title: 'Error',
                text: e.message,
                type: 'error',
            });
        }

    }

    public async confirmWithCoinbase(amount: number) {
        const payload = {
            username: this.username,
            ggcAmount: parseFloat(String(amount * 100)),
            redirectUrl: "https://golagol.com/lobby",
            cancelUrl: "https://golagol.com/lobby",
        };

        try {
            this.coinbaseData = await addFundsService.coinbaseDeposit(payload);
            this.coinbaseData.success = true;
        } catch (e) {
            this.coinbaseData.success = false;
            this.coinbaseData.message = e.message;
        }
    }

    private async confirmAddFunds() {
        const { method } = this.data;

        if (!this.data.amount || !this.data.method.length) {
            return
        }

        if (method[0] === 'directa24') {
            await this.confirmWithDirecta24(this.data.amount);
            return
        }

        await this.confirmWithCoinbase(this.data.amount);
        return;

    }

    private async mounted() {
        this.geoCode = 'ES'
    }
}
